import { withRBAC } from "../rbac";
import { QuickVendorCreateModal } from "./QuickVendorCreateModal";
import { VendorApprovalQueue } from "./VendorApprovalQueue";
import { VendorCreate } from "./VendorCreate";
import { VendorEdit } from "./VendorEdit";
import { VendorInviteButton } from "./VendorInviteButton";
import { VendorList } from "./VendorList";
import { VendorOnboardingPage } from "./VendorOnboardingPage";
import { VendorShow } from "./VendorShow";

export const vendors = {
  list: withRBAC(VendorList, "view_procurement"),
  show: withRBAC(VendorShow, "view_procurement"),
  create: withRBAC(VendorCreate, "manage_procurement"),
  edit: withRBAC(VendorEdit, "manage_procurement"),
  recordRepresentation: "name",
  VendorApprovalQueue: withRBAC(VendorApprovalQueue, "manage_procurement"),
};

export { VendorOnboardingPage, VendorInviteButton, QuickVendorCreateModal, VendorApprovalQueue };
